import { CREATE_BOOKABLE, SET_BOOKABLES, GET_BOOKABLES, UPDATE_BOOKABLE } from './actionTypes'

// TODO typing
export function createBookableSaga(data) {
  return {
    type: CREATE_BOOKABLE,
    data,
  }
}

export function updateBookableSaga(data) {
  return {
    type: UPDATE_BOOKABLE,
    data,
  }
}

export function setBookables(data) {
  return {
    type: SET_BOOKABLES,
    data,
  }
}

export function getBookablesSaga(data) {
  return {
    type: GET_BOOKABLES,
    data,
  }
}
